export default __webpack_public_path__ + "static/section1_banner-25912a7400d99522bc3343c3e21751a0.png";